import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const PeopleIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_572_10679)">
        <path
          d="M11.6618 10.4836L10.4275 10.8143C10.4233 12.3818 9.51764 13.9858 7.50394 14.5254C4.96884 15.2047 2.36308 13.7003 1.6838 11.1652C1.00452 8.63005 2.50896 6.02429 5.04406 5.34501C8.58454 4.39634 10.9917 7.98275 11.6618 10.4836Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.08352 10.75C6.66932 11.1642 6.66932 11.8358 7.08352 12.25C7.49773 12.6642 8.1693 12.6642 8.58351 12.25C8.99771 11.8358 8.99771 11.1642 8.58351 10.75C8.1693 10.3358 7.49773 10.3358 7.08352 10.75Z"
          fill="var(--cdl-bg-base)"
        />
        <path
          d="M10.7124 15.8902L11.616 16.7938C10.8358 18.1535 10.8181 19.9954 12.2923 21.4695C14.1481 23.3253 17.157 23.3253 19.0128 21.4695C20.8686 19.6137 20.8686 16.6048 19.0128 14.749C16.421 12.1572 12.5431 14.0595 10.7124 15.8902Z"
          fill="var(--cdl-bg-base)"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0838 18.7503C12.8077 19.0264 12.8077 19.4741 13.0838 19.7502C13.3599 20.0264 13.8076 20.0264 14.0838 19.7502C14.3599 19.4741 14.3599 19.0264 14.0838 18.7503C13.8076 18.4741 13.3599 18.4741 13.0838 18.7503Z"
          fill="currentColor"
        />
        <path
          d="M14.1215 8.67814L15.3558 8.34741C16.1432 9.70283 17.7295 10.6391 19.7432 10.0996C22.2783 9.42028 23.7828 6.81451 23.1035 4.27941C22.4242 1.74431 19.8184 0.239872 17.2833 0.91915C13.7429 1.86782 13.4514 6.17732 14.1215 8.67814Z"
          fill="var(--cdl-chart-green-base)"
          stroke="var(--cdl-chart-green-base)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5017 8.68877C17.1061 9.60881 18.3419 9.86468 19.262 9.26027C20.182 8.65586 20.4379 7.42005 19.8335 6.5L16.5017 8.68877Z"
          fill="var(--cdl-bg-base)"
        />
      </g>
      <defs>
        <clipPath id="clip0_572_10679">
          <rect
            width="24"
            height="24"
            fill="var(--cdl-bg-base)"
            transform="translate(0.333496)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PeopleIcon;
